<template>
    <div style="background-color: #F4F4F4;overflow: hidden">

        <div>
            <home_head></home_head>
        </div>
        <div class="body_list">
            <!--            顶部-->
            <div class="xiaoxi">
                <span>消息列表</span>
                <span @click="fanhui" style="float: right;color: #00a2d4;cursor: pointer">
                    返回上一页
                </span>
            </div>
          
            <!--            列表-->
            <div style="margin-top:20px" v-for="(item,index) in list" :key="index">
                <div v-if="data_id == item.member_a && data_id != item.member_b">
                    <div class="xiaoxi_list" v-if="item.member_a_delete == 0">
                        <a :href="'#/chat_room/' + data_id + '?uid=' + item.member_b">
                            <span v-if="item.unread_total == 0">
                                <img v-if="item.avatar_b" :src="url + '/storage/' + item.avatar_b" class="img">
                                <img v-else src="../../../assets/home/yixiaoxing_head.png" class="img">
                            </span>
                            <el-badge v-else :value="item.unread_total<=99?item.unread_total:'99+'" class="item">
                                <img v-if="item.avatar_b" :src="url + '/storage/' + item.avatar_b" class="img">
                                <img v-else src="../../../assets/home/yixiaoxing_head.png" class="img">
                            </el-badge>
                            <span class="yonghuming">{{ item.name_b }}</span>
                        </a>
                        <!--                        删除按钮-->
                        <span class="el-icon-delete" @click="removelist(item.id)"></span>
                    </div>
                </div>
                <div v-if="data_id == item.member_b">
                    <div class="xiaoxi_list" v-if="item.member_b_delete == 0">
                        <a :href="'#/chat_room/' + data_id + '?uid=' + item.member_a">
                            <span v-if="item.unread_total == 0">
                                <img v-if="item.avatar_a" :src="url + '/storage/' + item.avatar_a" class="img">
                                <img v-else src="../../../assets/home/yixiaoxing_head.png" class="img">
                            </span>
                            <el-badge v-else :value="item.unread_total<=99?item.unread_total:'99+'" class="item">
                                <img v-if="item.avatar_a" :src="url + '/storage/' + item.avatar_a" class="img">
                                <img v-else src="../../../assets/home/yixiaoxing_head.png" class="img">
                            </el-badge>
                            <span class="yonghuming">{{ item.name_a }}</span>
                        </a>
                        <!--                        删除按钮-->
                        <span class="el-icon-delete" @click="removelist(item.id)"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import head from "../../common/head";
  export default {
    name: "chat_list",
    data(){
      return{
        list:[],
        url:'',
        data_id:'',
        list_id:[],
      }
    },
    methods:{
      init(){
        this.get_list();
        this.url = window.config.api_url;
      },
      //获取列表
      get_chatlist(){
        let t = this;
        if (document.location.protocol == 'http:'){
          let url = 'http://ws.yi-mix.com/chat/room?uid=' + this.data_id;
          t.axios.get(url).then(res=>{
            t.list = res.data
          })
        }else {
          let url1 = 'https://ws.yi-mix.com/chat/room?uid=' + this.data_id;
          t.axios.get(url1).then(res=>{
            t.list = res.data
          })
        }
      },
      fanhui(){
        this.$router.go(-1);
      },
      //删除一行
      removelist(chat_id){
        let t = this;
        if (document.location.protocol === 'http:'){
          let aid = localStorage.getItem('uid');
          let url = 'http://ws.yi-mix.com/chat/delete?token=' + aid + '&chat_id='+ chat_id + '&uid=' + this.data_id;
          t.axios.get(url).then(()=>{
            t.get_chatlist();
          })
        }else {
          let aid = localStorage.getItem('uid');
          let url = 'https://ws.yi-mix.com/chat/delete?token=' + aid + '&chat_id='+ chat_id + '&uid=' + this.data_id;
          t.axios.get(url).then(()=>{
            t.get_chatlist();
          })
        }
        this.$message({
          message:'已删除',
          type:'success',
        })
      },
      //获取uid
      get_list(){
        let t = this;
        let aid = localStorage.getItem('uid');
        let url = window.config.api_url + '/user/shop/info?token=' + aid;
        t.axios.get(url).then((res)=>{
          t.data_id = res.data.shop_info.uid
          t.get_chatlist();
        })
      },
    },
    components:{
      'home_head':head,
    },
    computed:{

    },
    created() {
      this.init();
    },
    // mounted() {
    //   if (location.href.indexOf("#reloaded") == -1){
    //     location.href = location.href + "#reloaded";
    //     location.reload();
    //   }
    // },
  }
</script>

<style scoped>
    .body_list  {
      background-color: white;
      min-height:1000px;
      height: 100%;
      width: 50%;
      margin: 35px 25%;
    }
    .xiaoxi{
        width: 100%;
        background-color: #f4f4f4;
        height: 10%;
        font-size: 20px;
    }
    .xiaoxi_list{
        background-color: #f4f4f4;
        height: 80px;
        width: 95%;
        margin-left: 16px;
        margin-bottom: 10px;
        border-radius: 10px;
    }
    .yonghuming{
        /*margin-left: 10px;*/
        position: absolute;
        margin-top: 20px;
        font-family: 黑体;
        font-size: 15px;
        color: black;
    }
    .el-icon-delete{
        float: right;
        margin: 34px;
        color: #8c939d;
        cursor: pointer;
    }
    .img{
        width: 55px;
        height: 55px;
        margin: 13px;
        border-radius: 10px;
    }
</style>